import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonOutlineComponent } from './button-outline.component';


@NgModule({
  declarations: [
    ButtonOutlineComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ButtonOutlineComponent
  ]
})
export class ButtonOutlineModule { }
